/**
 * Shared tool components index
 * Centralized exports for standardized calculator components
 */

// Core calculator components
export { StandardHeroCard } from './standard-hero-card'
export { RecommendationsGrid, presetSections } from './recommendations-grid'
export { UnifiedShareButton } from './unified-share-button'
export { LawnPrefillBanner } from './lawn-prefill-banner'

// First-time user experience components
export { TermTooltip, TermTooltipInline, TermHighlighter } from './term-tooltip'
export { WhatThisMeansCard, WhatThisMeansInline, interpretations } from './what-this-means-card'
export { CollapsibleSection, CollapsibleInline, CollapsibleGroup } from './collapsible-section'
export { PriorityBadge, PriorityDot, ActionStep, ActionStepList } from './priority-badge'
export { SuccessIndicator, StatusCheck, MultiValueComparison } from './success-indicator'
export { ResultSuccessCard } from './result-success-card'
export type { ResultSuccessCardCta, ResultSuccessCardStat } from './result-success-card'
export { ResultEmailCaptureCard } from './result-email-capture-card'
export { FaqSchema } from './faq-schema'
export { HowToSteps } from './howto-steps'

// Polish-pass shared components (herbicide timing + future tool refreshes)
export { HeadlineHero } from './headline-hero'
export { CalendarWindow, Stat as CalendarStat } from './calendar-window'
export { ApproachCard, EdgeCard } from './approach-card'
export type { ApproachKind, EdgeCardStat } from './approach-card'

// Pre-submission affiliate picks (tank-mix pattern, server-shell rendered)
export { ToolPicksBlock } from './tool-picks-block'
export type { ToolPick } from './tool-picks-block'

// One product row inside a computed result (`tool-result:<slug>` surface)
export { ToolResultPick, useActiveResultAsin } from './tool-result-pick'
export { AffiliateDisclosure } from './affiliate-disclosure'

// Cross-tool navigation
export { RelatedTools } from './related-tools'
export { ToolNextStepCard } from './tool-next-step-card'
export { ToolPageLoadingFallback } from './tool-page-loading-fallback'

// Data visualization wrapper used by per-tool chart bodies (see components/tools/charts/)
export { ToolDataChart, ToolDataChartSkeleton } from './tool-data-chart'

// Core types
export type {
  Metric,
  StatusConfig,
  BannerConfig,
  StatusLevel,
  RecommendationVariant,
  RecommendationSection,
  ShareConfig,
  GridLayout,
} from './types'

// First-time UX types
export type {
  WhatThisMeansConfig,
  TermDefinition,
  PriorityConfig,
  SuccessIndicatorConfig,
  CollapsibleConfig,
} from './types'
